module.exports = __webpack_public_path__ + "static/img/honor28.07fa6fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor28.png
// module id = Z6EB
// module chunks = 0